
import React from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface ExchangeSelectionProps {
  value: string;
  onChange: (value: string) => void;
}

export const ExchangeSelection = ({ value, onChange }: ExchangeSelectionProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor="exchange">Exchange</Label>
      <Select
        value={value}
        onValueChange={onChange}
        required
      >
        <SelectTrigger id="exchange">
          <SelectValue placeholder="Select an exchange" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="OKX">OKX</SelectItem>
          <SelectItem value="Bybit">Bybit</SelectItem>
          <SelectItem value="Bitget">Bitget</SelectItem>
          <SelectItem value="Phemex">Phemex</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
